/* eslint-disable import/prefer-default-export */

import { GET_DASHBOARD_DISCUSSIONS_REQUEST, GET_DASHBOARD_DISCUSSIONS_SUCCESS, GET_DASHBOARD_DISCUSSIONS_FAIL, RESET_DASHBOARD_DISCUSSIONS } from '../constants';
import { buildQuery } from '../helpers';
export function getFollowedDiscussions() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    page: 1,
    perPage: 20,
    sort: '-createDate',
    search: ''
  };
  var query = buildQuery(params);
  return {
    types: [GET_DASHBOARD_DISCUSSIONS_REQUEST, GET_DASHBOARD_DISCUSSIONS_SUCCESS, GET_DASHBOARD_DISCUSSIONS_FAIL],
    promise: function promise(fetch) {
      return fetch("/api/discussions?".concat(query), {
        method: 'GET'
      });
    }
  };
}
export function resetFollowedDiscussion() {
  return {
    type: RESET_DASHBOARD_DISCUSSIONS
  };
}